import { render, staticRenderFns } from "./addParametro.vue?vue&type=template&id=c42306e4&scoped=true"
import script from "./addParametro.vue?vue&type=script&lang=js"
export * from "./addParametro.vue?vue&type=script&lang=js"
import style0 from "./addParametro.vue?vue&type=style&index=0&id=c42306e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42306e4",
  null
  
)

export default component.exports